/**
 * React Kendo UI Bundle
 *
 * version <tt>$ Version: 1.0 $</tt> date:2016/03/08
 * author <a href="mailto:hrahn@nkia.co.kr">Ahn Hyung-Ro</a>
 *
 */
'use strict';

//  Kendo UI Components
import * as Kendo from './index';

// console.log('PRODUCTION', PRODUCTION);
// console.log('VERSION', VERSION);

module.exports = {
    ...Kendo
};


// WEBPACK FOOTER //
// ./src/umd.js